<template>
  <!-- 案件詳細 -->
  <div id="KenshinDivisionRequestAcceptDetail">
    <div id="container">
      <div class="labelTitle lable">企業検診 企業検診グループ受付</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td><a @click="showDetail(data.receiptNumber)">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a></td>
            </tr>
            <tr>
              <th>申込日</th>
              <td>{{data.applicationDate}}</td>
            </tr>
            <tr>
              <th>検査種類</th>
              <td>{{data.inspectionKind | inspectionKindFilter(inspectionKindList)}}<span v-if="data.demo" class="demo"/></td>
            </tr>
            <tr>
              <th>出荷希望週</th>
              <td>{{data.shippingDate}} ～ 
                <a @click="shippingCalenderActive = true"><b-icon icon="calendar-month"></b-icon></a>
              </td>
            </tr>
            <tr>
              <th>台数</th>
              <td>{{data.units}}</td>
            </tr>
            <tr>
              <th>企業名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.companyName}}</td>
            </tr>
            <tr>
              <th>依頼元</th>
              <td>{{data.client}}<span v-if="data.proxyFlag" class="agent"/></td>
            </tr>
            <tr>
              <th>機種<span class="require"/></th>
              <td><select id="model" v-model="data.model" style="height:28px;"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
            </tr>
            <!-- 判定有無 -->
            <tr v-if="data.isJudgment">
              <th>判定医<span class="require"/></th>
              <td><input id="judgmentName" type="text" readonly v-model="data.judgmentName" disabled style="width:500px;height:28px;"/><b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">判定医選択</b-button></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">検診情報備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.note}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">検診グループ受付備考</th>
              <td><textarea v-model="data.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" icon-left="stamper" @click="receptionist">受付</b-button>
          <b-button class="receptionistButton is-primary" @click="cancelReasonInputModalActive=true">却下</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
          <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
            <reasonInputModal  v-on:setReason="cancel" v-bind:title="'却下(キャンセル理由入力)'"></reasonInputModal>
          </b-modal>
        </div>
      </div>
    </div>
    <floatingDiv v-if="isShowDetail" @close="closeDetail" title="" width="900px" height="480px" top="100px" right="100px">
      <kenshinRequestDetail :data="data.applicationDetails"/>
    </floatingDiv>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <judgmentDoctorSelectModal :selectRole="[role.role_judgment]" @select="setJudgmentName"></judgmentDoctorSelectModal>
    </b-modal>
    <floatingDiv v-if="shippingCalenderActive" @close="closeShippingCalender" title="" width="1250px" height="800px" top="100px" right="100px">
        <shippingCalenderModal style="width:600px;"></shippingCalenderModal>
    </floatingDiv>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import JudgmentDoctorSelectModal from "@/components/mock/philips/common/JudgmentDoctorSelectModal";
import ShippingCalenderModal from "@/components/mock/philips/calender/ShippingCalender";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";

export default {
  name: "KenshinDivisionRequestAcceptDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinDivisionRequestAccept",
        params: { searchConditions: this.searchParams },
      });
    },
    receptionist: async function() {
      var errMsg = ""
      // 機種
      var element = document.getElementById("model");
      element.style["border-color"] = "";
      if(!this.data.model){
        element.style["border-color"] = "red";
        errMsg = "機種は必須項目です。\n"
      }
      // 判定医
      if(this.data.isJudgment){
        var element2 = document.getElementById("judgmentName");
        element2.style["border-color"] = "";
        if(!this.data.judgmentName){
          element2.style["border-color"] = "red";
          errMsg = errMsg + "判定医は必須項目です。"
        }
      }
      if(errMsg){
        this.showErrorMessage(errMsg)
        return;
      }
      var excuteApi = this.setKenshinExaminationReceptionPOST;
      var successCallBack = this.setKenshinExaminationReceptionPOSTSuccess;
      var errorCallBack = this.setKenshinExaminationReceptionPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinExaminationReceptionPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      delete obj.applicationDetails
      return client.apis.internalKenshin.setKenshinExaminationReceptionPOST({ 
        body:obj
      });
    },
    setKenshinExaminationReceptionPOSTSuccess: function(result) {
      this.showSuccess(result,this.back())
    },
    setKenshinExaminationReceptionPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    cancel: function(reason) {
      // 却下
      this.cancelReason = reason
      var excuteApi = this.setKenshinExaminationRejectedPOST;
      var successCallBack = this.setKenshinExaminationRejectedPOSTSuccess;
      var errorCallBack = this.setKenshinExaminationRejectedPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinExaminationRejectedPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.reason = this.cancelReason
      delete obj.applicationDetails
      return client.apis.internalKenshin.setKenshinExaminationRejectedPOST({
        body:obj
      });
    },
    setKenshinExaminationRejectedPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setKenshinExaminationRejectedPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(id) {
      this.isShowDetail = true;
    },
    closeDetail: function(){
      this.isShowDetail = false;
    },
    closeShippingCalender: function(){
      this.shippingCalenderActive = false;
    },
    setJudgmentName: function(selectedJudgment){
      this.data.judgmentId = selectedJudgment.belongsId;
      this.data.judgmentName = selectedJudgment.hospitalName;
    },
    doSearch: function() {
      var excuteApi = this.getKenshinExaminationReceptionDetailPOST;
      var successCallBack = this.getKenshinExaminationReceptionDetailPOSTSuccess;
      var errorCallBack = this.getKenshinExaminationReceptionDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinExaminationReceptionDetailPOST: function(client) {
      return client.apis.internalKenshin.getKenshinExaminationReceptionDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getKenshinExaminationReceptionDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getKenshinExaminationReceptionDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    let inspectionKindList = this.getChoiceList(choicesType.kenshinKind, false);
    inspectionKindList.unshift({})
    let kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    return {
      role: role,
      choicesType:choicesType,
      data: [],
      organizationModalActive: false,
      shippingCalenderActive: false,
      isShowDetail: false,
      targetNumber,
      searchParams,
      inspectionKindList,
      kenshinDeviceList,
      cancelReasonInputModalActive:false,
      cancelReason:""
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.doSearch();
  },
  filters: {
    inspectionKindFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: { 
    floatingDiv: floatingDiv,
    judgmentDoctorSelectModal:JudgmentDoctorSelectModal,
    shippingCalenderModal: ShippingCalenderModal,
    kenshinRequestDetail:KenshinRequestDetail,
    reasonInputModal:reasonInputModal
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinDivisionRequestAcceptDetail.vue